import React, { useContext } from 'react';
import Cookies from 'js-cookie';

import UiContext from 'common/UiContext/UiContext';

import classNames from 'classnames';
import Icons from 'assets/images/Icons';

import ITheme from 'common/types/ITheme';

import './theme-switcher.scss';

const ThemeSwitcher = () => {

  const { theme, setTheme } = useContext(UiContext);

  const switchThemes = () => {
    setTheme!((current) => {
      const newTheme: ITheme = 'dark' === current ? 'light' : 'dark';

      Cookies.set('theme', newTheme, {
        expires: 90,
        secure: true,
      });

      return newTheme;
    });
  };

  return (
    <div className='theme-switcher' onClick={switchThemes}>
      <div className={classNames({ active: 'dark' === theme, 'switcher-placeholder': true })}>
        <Icons name='Dark' />
        dark
      </div>
      <div className={classNames({ active: 'light' === theme, 'switcher-placeholder': true })}>
        <Icons name='Light' />
        light
      </div>
      <div className={classNames({ switcher: true, [theme as string]: true })}>
      </div>
    </div>
  );
};

export default ThemeSwitcher;